module.exports = __webpack_public_path__ + "static/phones-56565ccb76b4d4f8380eabfc5411276a.png";